import react, {useState, useEffect} from "react";
import { Image as AntdImage, Modal, Form, Input, Spin } from "antd";


import Api from "../../../api";
import BackIcon from "../../../components/BackIcon/index";
import TeamModal from "./teamModal";
import "./index.scss"

const MyTeam = () => {

    const [loading, setLoading] = useState(false);
    const [teamList, setTeamList] = useState([]);
    const [teamOpen, setTeamOpen] = useState(false);
    const [teamTitle, setTeamTitle] =  useState("");

    useEffect(()=>{
        getTeamList();
    },[])

    const getTeamList = async()=>{
        setLoading(true);
        try{
            let res = await Api.Team.queryTeamList();
            setLoading(false);
            if(res.data && res.code === 0){
                setTeamList(res.data)
            }
        }catch(error){
            setLoading(false);
        }
    }

    const headleAddTeam = () => {
        setTeamOpen(true);
        setTeamTitle("添加团队")
    }

    const teamCancel = () => {
        setTeamOpen(false);
        setTeamTitle("");
        getTeamList();
    }

    const viewDetails = (id) =>{
        window.open("/page/manage/teamDetails?id="+id);
    }

    return (
        <div className="myTeamFrame">
            <div className="title">团队管理</div>
            <BackIcon />
            <div className="contentBox">
                <Spin spinning={loading}>
                    <div className="teamList">
                        <div className="teamListItem addTeamBox" onClick={headleAddTeam}>
                            <i className="iconfont icon-jia" />
                            <span className="btnText">新建团队</span>
                        </div>

                        {teamList.map((item, index) => (
                            <div className="teamListItem" key={index} onClick={()=>viewDetails(item.id)}>
                                <span className="teamName" title={item.teamName}>{item.teamName}</span>
                                <span className="teamDesc" title="item.teamDesc">{item.teamDesc}</span>
                                <span className="createTime">{item.createTime}</span>
                                <span className="personNum">{item.teamNum || 0}</span>
                            </div>
                        ))}
                        
                    </div>
                </Spin>
            </div>

            <TeamModal
                teamTitle={teamTitle}
                open={teamOpen}
                teamCancel={teamCancel}
                details={{}}
            />

        </div>
    )
}

export default MyTeam;